import { createStore } from 'vuex'

export default createStore({
  state: {
    navIndex: localStorage.getItem('navIndex') || 0
  },
  getters: {
  },
  mutations: {
    setNavIndex(state: any, index: any) {
      localStorage.setItem('navIndex', index);
      state.navIndex = index;
      console.log('localStorage store change: ',localStorage.getItem('navIndex'))
    }
  },
  actions: {
  },
  modules: {
  }
})
